import * as React from 'react'
function SvgZoomMinus(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M18.365 4c7.34 0 13.176 6.024 13.176 13.365 0 3.011-.941 5.647-2.635 7.906l5.647 5.835c.753.753.753 1.882 0 2.635-.377.377-.941.565-1.318.565-.376 0-.94-.188-1.317-.565l-5.647-5.647c-2.071 1.694-4.895 2.635-7.906 2.635C11.024 30.73 5 24.706 5 17.365 5 10.024 11.024 4 18.365 4zm0 3.765c-5.27 0-9.6 4.33-9.6 9.6s4.33 9.411 9.6 9.411 9.6-4.14 9.6-9.411c0-5.27-4.33-9.6-9.6-9.6zm3.576 7.53a1.882 1.882 0 010 3.764h-7.53a1.882 1.882 0 110-3.765h7.53z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgZoomMinus
